module.exports = __webpack_public_path__ + "media/components/Header/static/logo-narrow-cf053e280865747d6099bb7455d4254b.svg";